// Copyright (c) 2022 WiseTime. All rights reserved.

import { EMPTY, Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import {
  CancelPostTimeRequest,
  CancelPostTimeResponse
} from "../../../generated/wisetime/user/timeline/v4/timeline_pb"
import { grpc } from "../../../app/rpc/executor"
import { timelineClient } from "../../../app/rpc/client"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"

type CancelPostTimeRpc = (request: CancelPostTimeRequest) => Observable<CancelPostTimeResponse>

export const cancelPostTime = (cancelPostRpc: CancelPostTimeRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.cancelPostTime.match),
      mergeMap(action => of(action.payload)
        .pipe(
          mergeMap(cancelPostRpc),
          mergeMap(_ => EMPTY),
          catchError(_ => (
            of(showSnackBar({
              message: t({ id: "msg_cancel_post_time_failed", message: "Unable to cancel post time. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
              messageType: "ERROR",
            }))
          )),
        )
      ),
    )

const cancelPostRpc = (request: CancelPostTimeRequest): Observable<CancelPostTimeResponse> =>
  grpc(() => timelineClient.cancelPostTime(request, null))

export default cancelPostTime(cancelPostRpc)
